import * as React from 'react';

const EmailVerifyIcon = (props) => (
  <svg
    width={120}
    height={120}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.1} cx={60} cy={60} r={60} fill="#6B3EB4" />
    <circle opacity={0.3} cx={60} cy={60.0003} r={39.2727} fill="#6B3EB4" />
    <path
      // eslint-disable-next-line max-len
      d="M59.6363 41.4546C49.6181 41.4546 41.4545 49.6182 41.4545 59.6364C41.4545 69.6546 49.6181 77.8182 59.6363 77.8182C69.6545 77.8182 77.8181 69.6546 77.8181 59.6364C77.8181 49.6182 69.6545 41.4546 59.6363 41.4546ZM68.3272 55.4546L58.0181 65.7637C57.7636 66.0182 57.4181 66.1637 57.0545 66.1637C56.6908 66.1637 56.3454 66.0182 56.0908 65.7637L50.9454 60.6182C50.4181 60.091 50.4181 59.2182 50.9454 58.691C51.4726 58.1637 52.3454 58.1637 52.8726 58.691L57.0545 62.8728L66.3999 53.5273C66.9272 53 67.7999 53 68.3272 53.5273C68.8545 54.0546 68.8545 54.9091 68.3272 55.4546Z"
      fill="#6B3EB4"
    />
    <path
      d="M52.5756 59.6659L57.4169 64.3635L66.4944 54.9683"
      stroke="white"
      strokeWidth={4.52363}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EmailVerifyIcon;
